<template>
  <div
    class="info-box"
    :class="{ 'info-box--image': isImageBox }">
    <!-- Regular content box -->
    <template v-if="!isImageBox">
      <custom-text
        :text="title"
        color="black" />
      <div class="info-content">
        <slot />
      </div>
    </template>

    <!-- Image box with CTA -->
    <template v-else>
      <div class="kitchen-display">
        <div class="kitchen-display__cta">
          <slot name="cta" />
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
  defineProps({
    title: {
      type: String,
      default: ''
    },
    isImageBox: {
      type: Boolean,
      default: false
    },
    backgroundImage: {
      type: String,
      default: ''
    }
  })
</script>

<style lang="scss" scoped>
.info-box {
  flex: 1;
  padding: 40px 32px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 300px;

  &:not(:last-child) {
    border-right: 1px solid #e5e5e5;

    @include up-to-tablet {
      border-right: none;
      border-bottom: 1px solid #e5e5e5;
    }
  }

  &--image {
    background-image: url("~/assets/images/horizontal.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    min-height: 300px;
    display: flex;
    flex-direction: row; // Override parent flex-direction
    align-items: flex-end;
    justify-content: flex-start;
    padding: 40px 32px 32px;

    @include up-to-tablet {
      min-height: 200px;
      padding: 32px 24px 24px;
      border-radius: 10px;

      // overflow: hidden;
      margin-left: var(--space-s);
      margin-right: var(--space-s);
    }
  }

  @include up-to-tablet {
    padding: 24px 20px;
    min-height: 250px;
  }
}

.info-content {
  overflow: hidden;
  margin-top: var(--space-s);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.kitchen-display {
  width: 100%;

  &__cta {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
  }
}
</style>
